module.exports = {"object":"value","document":{"object":"document","nodes":[{"object":"block","type":"paragraph","nodes":[{"object":"text","text":"In addition to simple image nodes, you can actually create complex embedded nodes. For example, this one contains an input element that lets you change the video being rendered!"}]},{"object":"block","type":"video","data":{"video":"https://www.youtube.com/embed/FaHEusBG20c"}},{"object":"block","type":"paragraph","nodes":[{"object":"text","text":"Try it out! If you want another good video URL to try, go with: https://www.youtube.com/embed/6Ejga4kJUts"}]}]}}


//////////////////
// WEBPACK FOOTER
// ./examples/embeds/value.json
// module id = 760
// module chunks = 0